import { Validators } from '@angular/forms';
import {
  TypedFormGroup,
  TypedFormArray,
  TypedFormControl,
  TypedAbstractControl,
} from '@principle-theorem/ng-shared';
import {
  IAccTeeth,
  IAccToothInjury,
} from '@principle-theorem/principle-core/interfaces';
import { AccToothInjuryFormGroup } from './acc-tooth-injury.formgroup';

export class AccTeethFormGroup extends TypedFormGroup<IAccTeeth> {
  constructor() {
    super({
      injuries: new TypedFormArray<IAccToothInjury>([
        new AccToothInjuryFormGroup(),
      ]), // At least one tooth injury is required per API spec
      additionalInjuryComment: new TypedFormControl<string>(
        undefined,
        Validators.maxLength(500)
      ),
    });
  }

  addToothInjuryForm(): void {
    this.toothInjuryFormArray.push(new AccToothInjuryFormGroup());
  }

  removeToothInjuryForm(index: number): void {
    const form = this.toothInjuryFormArray.at(index) as AccToothInjuryFormGroup;
    form.destroy();
    this.toothInjuryFormArray.removeAt(index);
  }

  get toothInjuryFormArray(): TypedFormArray<IAccToothInjury> {
    return this.controls.injuries as TypedFormArray<IAccToothInjury>;
  }

  get toothInjuryControls(): AccToothInjuryFormGroup[] {
    return this.toothInjuryFormArray.controls as AccToothInjuryFormGroup[];
  }

  get additionalInjuryCommentControl(): TypedAbstractControl<
    string | undefined
  > {
    return this.controls.additionalInjuryComment;
  }
}
